import React, { Component } from 'react';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/messages';
import { MessagesService } from '../../api/message-services';
import Truncate from 'react-truncate';
import { SecureImage } from '../../components/core/secureImage';
import Moment from 'moment';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import ReactGA from 'react-ga4';

const _logger = Log.create('conversationListItem');
let _common: Common;
const messagesService = new MessagesService();
const T = Translator.create();
const defaultChatLogo = `${process.env.PUBLIC_URL}/images/message/message.jpg`;
export class CConversationListItem extends Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    openChat = (messageId = '') => {
        if (this.props.isGroup) {
            ReactGA.event({
                category: window.location.host,
                action: 'G_GROUP_MESSAGES_OPEN_CHAT_CLICKED',
                label: 'G_GROUP_MESSAGES_OPEN_CHAT_CLICKED',
                nonInteraction: true,
            });
        }
        else {
            ReactGA.event({
                category: window.location.host,
                action: 'G_PERSONAL_MESSAGES_OPEN_CHAT_CLICKED',
                label: 'G_PERSONAL_MESSAGES_OPEN_CHAT_CLICKED',
                nonInteraction: true,
            });
        }

        if (this.props.messageModelClosed)
            {

                this.props.triggerMessageModalClosed();
            }

        let calledMessageId = messageId || this.props.originMessageId;
        let chatTitleText = this.props.isGroup ? this.props.name : this.props.recipientName;
        this.props.dispatch(Actions.setOriginMessageIdAction(calledMessageId, chatTitleText, this.props.images));

        this.props.dispatch(
            Actions.getMessageListAction({
                skip: 0,
                take: 10,
                originMessageId: calledMessageId,
                contextType: this.props.isGroup ?  1: 0,
                contextId: this.props.lastSenderId,
                imageUrl: this.props.images,
                chatTitleText: chatTitleText,
                spinnerId: 'getMessageListAction',
                spinnerType: 'get',
                callback: this.openChatCallBack
            })
        );
    };

    openChatCallBack = () => {
        const item = document.getElementById('chatPanel');
        if (item) {
            item.className = 'conversation-window relative mobile_chat_panel display_sm';
        }
    }

    getImageUrl = (images: any) => {
        if(!this.props.isGroup){

        if (images && typeof images === 'string') {
            return images;
        } else if (images && typeof images === 'object') {
            return images[0];
        }
    }
    else{
        return defaultChatLogo
    }
    };

    improveV3Message = (message: any) => {
        const plaintext = message.replace(/<blockquote>.*?<\/blockquote>/, '');
        return plaintext
    }

    getMessageText = () => {
        if (this.props.lastMessage) {
            const text = this.improveV3Message(this.props.lastMessage);
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const plainText = doc.body.textContent ?? "";

            return plainText;
        }
        return '';
    };

    public render() {


        let lastMessageDateString = '';
        let lastMessageDateStringFromNow = '';

        if (this.props.lastMessageDate) {
            const t = Moment(this.props.lastMessageDate).locale(T.i18next.language);
            lastMessageDateString = t.format(_common.GetDateFormatFromPrefrences(this.props.userPreferences, 1) + ' HH:mm:ss');
            lastMessageDateStringFromNow = t.fromNow();
        }

        return (
            <div id={this.props.id} className="media" onMouseDown={event => this.openChat('')}>
               {this.props.isGroup ? <img className="chat_avatar" src={this.getImageUrl(this.props.images)} /> : <SecureImage class="chat_avatar" imageUrl={this.getImageUrl(this.props.images)} />}
                <div
                    className="media-body"
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        minHeight: '55px'
                    }}
                >
                    <div className="message-intro ">
                        <div className="chat_label_width">
                            <div className={"chat_label_text"+(!_common.isArabic(this.props.isGroup ? this.props.name : this.props.recipientName, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} tabIndex={0}>{this.props.isGroup ? this.props.name : this.props.recipientName}</div>
                            <div className=" message-intro-timer">
                                <span title={lastMessageDateString} tabIndex={0}>{lastMessageDateStringFromNow}</span>
                            </div>
                        </div>
                        <h6 className={(!_common.isArabic(this.props.lastMessage, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                            <Truncate lines={3} tabIndex={0}>
                                {this.props.isGroup && this.props.lastSenderName !== null ? `${this.props.lastSenderName}: ` : ''}
                                {this.getMessageText()}
                            </Truncate>
                        </h6>
                    </div>
                    {this.props.lastSenderId && this.props.lastSenderId === this.props.thisUserId &&
                        <>
                            {this.props.myUnreadCount === 0 && this.props.isDelivery &&
                                <div className="side-option">
                                    <i className="material-icons active icon-rtl">done_all</i>
                                </div>}
                            {this.props.myUnreadCount === 0 && !this.props.isDelivery &&
                                <div className="side-option">
                                    <i className="material-icons active icon-rtl">done</i>
                                </div>}
                        </>
                    }
                    {this.props.myUnreadCount > 0 &&
                        <div className="message-count side-option" style={{top: "55%"}} tabIndex={0}>
                            {this.props.myUnreadCount}
                        </div>}
                </div>
            </div>
        );
    }
}

export default CConversationListItem;
